import request from "@/utils/request";
export var BASE = '/api';
export var ECARGO_PATH = '/ecargocredit'; //电子保单打印 对接平安

export function policyPrintForPa(data) {
  return request({
    url: '/ecargoapis/smallPolicy/policyPrint',
    method: 'post',
    data: data
  });
} // 信用险投保---暂存

export function saveInfo(data) {
  return request({
    url: '/ecargocredit/credit/temStorageOrSubmit',
    method: 'post',
    data: data
  });
} // 信用险投保---获取投保申请基本信息中基础下拉框数据接口

export function baseInfo(data) {
  return request({
    url: '/ecargocredit/credit/getCreditBcCodeList',
    method: 'post',
    data: data
  });
} //信用险投保--投保人信息等数据接口

export function applyInfo(data) {
  return request({
    url: '/ecargocredit/credit/getCustomRegisterInfo',
    method: 'post',
    data: data
  });
} //获取当前登录用户信息

export function getApplicantInfo(data) {
  return request({
    url: '/ecargoaccount/user/getSysUser',
    method: 'post',
    data: data
  });
} //获取所有保险公司(注册生效)数据

export function getAllValidInsuranceCompany(data) {
  return request({
    url: '/ecargoaccount/user/getAllValidInsuranceCompany',
    method: 'get',
    params: data
  });
} //获取当前登录用户的投保权限

export function getCheckVerifyPermissions(data) {
  return request({
    url: '/ecargoaccount/user/checkVerifyPermissions',
    method: 'post',
    data: data
  });
} // 信用险投保--查询暂存的数据

export function getInfo(data) {
  return request({
    url: '/ecargocredit/credit/check',
    method: 'post',
    data: data
  });
} // 信用险投保--审核记录查询

export function getRecord(data) {
  return request({
    url: '/ecargocredit/credit/insureApplyRecordQuery',
    method: 'post',
    data: data
  });
} // 信用险投保--获取各国家数据

export function getCountry(data) {
  return request({
    url: '/ecargocredit/creditCommon/getCountry',
    method: 'post',
    data: data
  });
} // 信用险投保--删除

export function delData(data) {
  return request({
    url: '/ecargocredit/credit/insureApplyDelete',
    method: 'post',
    data: data
  });
} // 不承保原因

export function notReson(data) {
  return request({
    url: '/ecargocredit/credit/notUnderWriteUpdate',
    method: 'post',
    data: data
  });
} // 承保录入提交接口

export function promiseData(data) {
  return request({
    url: '/ecargocredit/credit/underWriteSubmit',
    method: 'post',
    data: data
  });
} // 保费币种

export function coinData(data) {
  return request({
    url: '/commondictionary/dictionary/codeTypeList',
    method: 'post',
    data: data
  });
} // 信用险投保单--影像上传

export function upLoads(data) {
  return request({
    url: "".concat(ECARGO_PATH, "/creditCommon/imageUploads"),
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'multipart/form-data;charset=UTF-8'
    }
  });
} // 信用险投保单--影像删除

export function deleteUpLoads(data) {
  return request({
    url: '/ecargocredit/creditCommon/deleteImagByImagCode ',
    method: 'post',
    data: data
  });
}